import { Component, Inject } from '@angular/core';
import { SnackBarService } from '../../../snackbar/snackbar.service';
import { FilterService } from '../../filter.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ColumnFilter } from 'src/app/common/models/request-data.model';
import { FilterListItemModel, SearchParam } from '../../search-filter.component';
import { SearchFilterSaveDialogComponent } from '../search-filter-save-dialog/search-filter-save-dialog.component';
import { SearchFilterLoadDialogComponent } from '../search-filter-load-dialog/search-filter-load-dialog.component';
import { SnackBarData } from '../../../snackbar/model/snackbar.model';
import { AppConstants } from 'src/app/common/app.constants';

@Component({
    selector: 'app-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['./filter-dialog.component.scss'],
    standalone: false
})
export class FilterDialogComponent {

  selectedColumnFilter: ColumnFilter[] = [];
  selectedFilters: FilterListItemModel[][] = [];
  searchInfo: any;
  filter?: FilterListItemModel[] = [];
  module: any;
  filterInfo: string = "0";
  user: any;

  constructor(public dialogRef: MatDialogRef<FilterDialogComponent>,
    private filterService: FilterService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBarService: SnackBarService,
    private dialog: MatDialog) {
      
    this.module = data.module;
    this.filter = data.filterOptions;
    this.setFilter(data.columnFilter)
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
    this.searchInfo={ id: 0, name: "", isFavorite: 0, module: this.module, filter: undefined, user_id: this.user.id };
  }


  saveClicked(): void {

    this.searchInfo.module = this.module;
    this.searchInfo.filter = this.selectedColumnFilter;
    const dialogRef = this.dialog.open(SearchFilterSaveDialogComponent, {
      width: '90%',
      maxWidth: '500px',
      height: '295px',
      data: this.searchInfo
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.searchInfo = result;
      } else {
        console.log('filter canceled');
      }
    });
  }

  /**
   * Remove all filters from selected filter array.
   */
  onFilterReset(): void {
    this.selectedFilters.length = 0;
    this.selectedColumnFilter.length = 0;
    this.searchInfo = { id: 0, name: "", isFavorite: 0, module: this.module, filter: undefined, user_id: this.user.id };

  }

  /**
   * Add new filter 
   */
  onFilterAdd(): void {

    let newFilter = JSON.parse(JSON.stringify(this.filter));
    this.selectedFilters.push(newFilter);
    this.selectedColumnFilter.push({ column: "", operator: "", value: "" })
  }
  

  /**
   * 
   * @param filter Remove the filter from selcted filters
   */
  onFilterRemove(index: any): void {
    this.selectedFilters.splice(index, 1);
    this.selectedColumnFilter.splice(index, 1);

  }

  /**
   * Emit the event with the selected filters
   */
  onFilterApply(): void {
    let searchFilterData: SearchParam = { advSearch: this.selectedColumnFilter, freeSearch: undefined };
    this.filterInfo = this.selectedColumnFilter.length + "";
    this.dialogRef.close(this.selectedColumnFilter);
  }

  cancel(): void {
    this.dialogRef.close();
  }


  /**
     * Loads predefined filter from saved list
     */
  onFilterLoad(): void {

    let searchInfo = { search: { filters: { simpleSearch: [], advSearch: [{ column: "module", operator: "=", value: this.module }, { column: "user_id", operator: "=", value: this.user.id }], scope: { limit: 50, offset: 0 } }, sort: [] } }
    this.filterService.getFilter(searchInfo).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          let searchFilter = response.data.filters;
          const dialogRef = this.dialog.open(SearchFilterLoadDialogComponent, {
            width: '90%',
            maxWidth: '500px',
            height: '500px',
            data: searchFilter
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.searchInfo = result;
              this.searchInfo.filter = JSON.parse(result.filter);
              this.setFilter(this.searchInfo.filter);

            } else {
              console.log('filter canceled');
            }
          });


        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        // handle error
        let snackBarData: SnackBarData = {
          message: 'Failed to update. Connection to the server failed',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }
  /**
   * Set the filters from pre loaded json
   */
  setFilter(columFilters: ColumnFilter[], apply?: boolean): void {
    this.selectedFilters.length = 0;
    this.selectedColumnFilter.length = 0;
    columFilters.forEach(f => {
      let newFilter = JSON.parse(JSON.stringify(this.filter));
      this.selectedFilters.push(newFilter);
      this.selectedColumnFilter.push({ column: f.column, operator: f.operator, value: f.value, type:f.type })
    });
    if (apply) {
      this.onFilterApply();
    }
  }
  
}
